import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Button,
  Box,
  Menu,
  MenuItem,
  IconButton,
  Tabs,
  Tab
} from '@mui/material';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import BusinessIcon from '@mui/icons-material/Business';
import AccountCircle from '@mui/icons-material/AccountCircle';
import SearchIcon from '@mui/icons-material/Search';
import HistoryIcon from '@mui/icons-material/History';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useAuth } from '../contexts/AuthContext';
import { useGlobalNotification } from '../App';

const Header = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const { isSearching } = useGlobalNotification();
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  // Determine current tab based on location
  const getCurrentTab = () => {
    if (location.pathname === '/') {
      return 0;
    } else if (location.pathname === '/search-history') {
      return 1;
    } else if (location.pathname === '/guide') {
      return 2;
    }
    return false; // No tab selected for other pages
  };

  const handleTabChange = (event, newValue) => {
    // Блокируем навигацию во время поиска
    if (isSearching) {
      return;
    }
    
    if (newValue === 0) {
      navigate('/');
    } else if (newValue === 1) {
      navigate('/search-history');
    } else if (newValue === 2) {
      navigate('/guide');
    }
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleClose();
    await logout();
    navigate('/login');
  };

  return (
    <AppBar position="static">
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <BusinessIcon sx={{ mr: 1 }} />
          <Typography
            variant="h6"
            noWrap
            component={isSearching ? 'div' : RouterLink}
            to={isSearching ? undefined : "/"}
            sx={{
              mr: 4,
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
              cursor: isSearching ? 'default' : 'pointer',
              opacity: isSearching ? 0.6 : 1,
            }}
          >
            FIT Audit
          </Typography>

          {/* Navigation Tabs - only show when authenticated */}
          {isAuthenticated && (
            <Box sx={{ flexGrow: 1 }}>
              <Tabs
                value={getCurrentTab()}
                onChange={handleTabChange}
                textColor="inherit"
                indicatorColor="secondary"
                sx={{
                  justifyContent: 'flex-end',
                  '& .MuiTabs-flexContainer': {
                    justifyContent: 'flex-end',
                  },
                  '& .MuiTab-root': {
                    color: 'rgba(255, 255, 255, 0.7)',
                    opacity: isSearching ? 0.3 : 1,
                    cursor: isSearching ? 'not-allowed' : 'pointer',
                    '&.Mui-selected': {
                      color: 'white',
                    },
                    '&.Mui-disabled': {
                      opacity: 0.3,
                    },
                  },
                }}
              >
                <Tab
                  icon={<SearchIcon />}
                  label="Поиск"
                  iconPosition="start"
                  disabled={isSearching}
                  sx={{ minHeight: 64 }}
                />
                <Tab
                  icon={<HistoryIcon />}
                  label="История поиска"
                  iconPosition="start"
                  disabled={isSearching}
                  sx={{ minHeight: 64 }}
                />
                <Tab
                  icon={<HelpOutlineIcon />}
                  label="Руководство"
                  iconPosition="start"
                  disabled={isSearching}
                  sx={{ minHeight: 64 }}
                />
              </Tabs>
            </Box>
          )}

          {isAuthenticated ? (
            <Box>
              <IconButton
                size="large"
                aria-label="аккаунт пользователя"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem disabled>
                  {user?.email || 'Пользователь'}
                </MenuItem>
                <MenuItem onClick={handleLogout}>Выйти</MenuItem>
              </Menu>
            </Box>
          ) : (
            <Box>
              <Button
                component={RouterLink}
                to="/login"
                color="inherit"
                variant="outlined"
              >
                Войти
              </Button>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
